import {useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import { TextField,Box, Dialog, makeStyles, Divider, withStyles, Button, Theme, createStyles, DialogContent } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import {useDispatch, useSelector} from "react-redux";
import { experiencesReload } from '../../../store/actions/experience/experience';
import {Loading} from '../commonLoadings';
import {renameExperience} from '../../../store/actions/experience/experience';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    maxWidth: 500,
    borderRadius: '24px!important'
  },
  btn: {
      width: 87,
      height: 37,
      borderRadius: 6,
      background: '#017AEF',
      color: '#fff',
      textTransform: 'none',
      fontSize: 14,
      '&:hover': {
          background: '#0f9fef',
          color: '#fff',
      },
  },
   cancelBtn: {
        margin: '0 15px',
        height: 37,
        borderRadius: 6,
        background: '#f2f2f2',
        textTransform: 'none',
        fontSize: 14,
        color: '#9ea6ae',
        '&:hover': {
          background: '#f2f2f2',
        },
    },
    contentText: {
      marginTop: '12px',
      fontFamily: 'roboto-regular',
    },
    experienceName: {
      marginTop: '12px',
      fontWeight: 'bold',
      fontFamily: 'roboto-regular',
    },
    label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

RenameExperienceModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  experienceData: PropTypes.object
};

RenameExperienceModal.defaultProps = {
  onClose: () => {
  }
};

function RenameExperienceModal({open, onClose,experienceData }: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const {loading} = useSelector((state: any) => state.creatorDashboard);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [experienceName, setExperienceName] = useState('');
  const [allowUpdate, setAllowUpdate] = useState(false);

  useEffect(() => {
    if(experienceData && experienceData.name){
      setExperienceName(experienceData.name)
      if(experienceData.name === experienceName){
        setAllowUpdate(false)
      }else{
        setAllowUpdate(true)
      }
    }
  }, [open]);

  const onRenameExperience = async () => {
    if (validateName(experienceName)) {
      const request = {
        session_title: experienceName,
        session_id: Number(experienceData.session_id),
      };
      await dispatch(experiencesReload());
      dispatch(renameExperience(apolloClient.client, request, () => onClose()))
      !loading && closeModal();
      setExperienceName('')
    }
  };

  // close modal
  const closeModal = () => {
    onClose()
    setExperienceName('')
  };

  const validateName = (experienceName: string) => {
    return experienceName.length > 1
  };

  const onChangeName = (event: any) => {
    setExperienceName(event.target.value);
    if(!event.target.value){
      setAllowUpdate(true)
      return
    }
    if(experienceData.name === event.target.value){
      setAllowUpdate(true)
    }else{
      setAllowUpdate(false)
    }
  };
  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      scroll='paper'
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogTitle onClose={closeModal}>
        Rename
      </DialogTitle>
      <Divider/>
      <DialogContent>
        <Box>
          <div className={classes.contentText}>
            <TextField
              value={experienceName}
              InputLabelProps={{
                classes: {
                  root: classes.label,
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: classes.underline,
                  error: classes.error
                }
              }}
              fullWidth
              size="small"
              id="experienceName"
              label="Experience Name"
              name="experienceName"
              onChange={onChangeName}
            />
          </div>
        </Box>
      </DialogContent>
         
      <Box mt={3} mb={3} mr={4} display='flex' justifyContent='flex-end'>
        {experienceData &&
          <>
            <Button className={classes.cancelBtn} onClick={closeModal}>
              Cancel
            </Button>
            <Button color='primary' disabled={allowUpdate} className={classes.btn} onClick={onRenameExperience} >
              {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Update'}
            </Button>
          </>
        }
      </Box>
    </Dialog>
  );
}

export default RenameExperienceModal;